import ApolloClient from "apollo-client"
import {HttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloLink} from "apollo-link";
import store from '../store/store'
import {createUploadLink} from "apollo-upload-client";

let uri = '/graphql/';
// if (process.env.NODE_ENV === 'production') {
uri = 'https://arstream.vitech.dev';
// }

if (process.env.VUE_APP_API_URL) {
  uri = process.env.VUE_APP_API_URL
}

// something to do
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri
});

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: store.state.auth.token || null
    }
  });
  return forward(operation);
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

const link = createUploadLink({
  // You should use an absolute URL here
  uri,
  fetch: customFetch
});

function customFetch(url, opts = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(opts.method || 'get', url);
    for (let k in opts.headers || {}) xhr.setRequestHeader(k, opts.headers[k]);

    xhr.onload = e =>
      resolve({
        ok: true,
        text: () => Promise.resolve(e.target.responseText),
        json: () => Promise.resolve(JSON.parse(e.target.responseText))
      });

    xhr.onerror = reject;

    if (xhr.upload)
      xhr.upload.onprogress = event => {
        if (opts.onProgress) {
          opts.onProgress(event.loaded / event.total * 100)
        }
      };

    xhr.send(opts.body)
  })
}

// Create the apollo client
const apolloUploadClient = new ApolloClient({
  link: middlewareLink.concat(link),
  cache: new InMemoryCache({
    // addTypename: false
  })
});

export {
  apolloClient,
  apolloUploadClient
}
